// Crumpled paper, drawn as flat-shaded facets lit from the top left. Flat planes
// with hard edges read as paper; the first prototype's thin stripes on a circle
// read as a ball of yarn. Used for the Rant Room's toss and as its card icon.

// The sheet's outline as 12 points, so a clip-path can morph a rectangle into a
// lumpy ball. Every frame needs the same point count or clip-path won't
// interpolate between them.
const poly = (pts) => `polygon(${pts.map(([x, y]) => `${x}% ${y}%`).join(',')})`;
export const OUTLINE_SHEET = poly([[0,0],[33,0],[66,0],[100,0],[100,33],[100,66],[100,100],[66,100],[33,100],[0,100],[0,66],[0,33]]);
export const OUTLINE_BUCKLE = poly([[6,10],[35,4],[64,9],[94,3],[97,36],[91,63],[96,95],[63,90],[36,97],[4,92],[10,62],[3,34]]);
export const OUTLINE_WAD = poly([[14,22],[34,6],[50,12],[70,2],[88,20],[84,38],[100,56],[86,80],[66,92],[44,100],[30,84],[6,74]]);
export const OUTLINE_BALL = poly([[20,10],[44,2],[62,8],[82,6],[96,28],[92,48],[100,66],[84,88],[60,98],[38,94],[14,84],[2,52]]);

const FACETS = [
  ['20,10 44,2 46,30', '#FFFEFB'], ['44,2 62,8 46,30', '#F6F3EC'], ['62,8 82,6 70,34', '#E9E5DA'],
  ['46,30 62,8 70,34', '#FBF9F4'], ['82,6 96,28 70,34', '#DCD7CB'], ['96,28 92,48 70,34', '#E4E0D5'],
  ['92,48 100,66 74,60', '#CFC9BB'], ['70,34 92,48 74,60', '#EEEAE1'], ['46,30 70,34 52,56', '#F8F6F0'],
  ['70,34 74,60 52,56', '#DEDACF'], ['20,10 46,30 22,44', '#F3F0E8'], ['2,52 20,10 22,44', '#FAF8F2'],
  ['22,44 46,30 52,56', '#E7E3D8'], ['2,52 22,44 30,70', '#E2DED3'], ['22,44 52,56 30,70', '#F1EEE6'],
  ['52,56 74,60 64,80', '#D6D1C4'], ['74,60 100,66 84,88', '#C8C1B2'], ['74,60 84,88 64,80', '#D1CBBD'],
  ['30,70 52,56 64,80', '#E5E1D6'], ['14,84 30,70 38,94', '#DAD5C9'], ['2,52 30,70 14,84', '#E9E5DB'],
  ['30,70 64,80 38,94', '#D9D4C7'], ['64,80 84,88 60,98', '#C4BDAD'], ['38,94 64,80 60,98', '#CEC8BA'],
];

// Stretches to fill its box (preserveAspectRatio none) — the toss scales the
// sheet non-uniformly, and the facets have to follow it.
const CrumpledPaper = ({ className = '', style }) => (
  <svg className={className} style={style} viewBox="0 0 100 100" preserveAspectRatio="none" aria-hidden="true">
    <rect width="100" height="100" fill="#ECE8DE" />
    {FACETS.map(([points, fill]) => <polygon key={points} points={points} fill={fill} />)}
    <polyline points="20,10 46,30 70,34 74,60 64,80 60,98" fill="none" stroke="rgba(120,110,90,0.35)" strokeWidth="0.8" />
    <polyline points="2,52 22,44 52,56 84,88" fill="none" stroke="rgba(120,110,90,0.3)" strokeWidth="0.7" />
    <polyline points="44,2 46,30 52,56 30,70 38,94" fill="none" stroke="rgba(255,255,255,0.8)" strokeWidth="0.7" />
  </svg>
);

// The finished ball at rest, for the Relax card.
export const PaperBall = ({ size = 32 }) => (
  <span
    className="block"
    style={{ width: size, height: size, filter: 'drop-shadow(0 2px 2px rgba(26,46,34,0.22))' }}
  >
    <span className="block w-full h-full" style={{ clipPath: OUTLINE_BALL }}>
      <CrumpledPaper className="block w-full h-full" />
    </span>
  </span>
);

export default CrumpledPaper;
